module.exports = __webpack_public_path__ + "static/media/14_BG_Blue.bd021285.png";